export const pickLocalized = (ru, en, locale = "ru") => {
  if (locale === "en") {
    const english = String(en || "").trim();
    if (english) return String(en);
  }
  return ru || "";
};

export const getLocalizedLibraryName = (file, locale = "ru") =>
  pickLocalized(file?.name, file?.name_en, locale);

export const getLocalizedLibraryPath = (file, locale = "ru") =>
  pickLocalized(file?.index_html_path, file?.index_html_path_en, locale);

export const libraryMatchesSearch = (file, searchValue = "") => {
  const needle = String(searchValue || "").trim().toLowerCase();
  if (!needle) return true;
  return [file?.name, file?.name_en]
    .filter(Boolean)
    .some((value) => String(value).toLowerCase().includes(needle));
};
